import React from 'react';
import {
  TableSortLabel, TableCell,
} from '@mui/material';
import { styled } from '@mui/material/styles';

const Item = styled('span')(() => ({
  border: 0,
  clip: 'rect(0 0 0 0)',
  height: 1,
  margin: -1,
  overflow: 'hidden',
  padding: 0,
  position: 'absolute',
  top: 20,
  width: 1,
}));

export default function TableHeaderCell(props) {
  const {
    headCell, orderBy, order, handleRequestSort,
  } = props;

  const onSortHandle = (event, property) => {
    let newOrder = 'asc';
    let newOrderBy = property;
    if (orderBy === property && order === 'asc') {
      newOrder = 'desc';
    }
    if (orderBy === property && order === 'desc') {
      newOrderBy = '';
    }
    handleRequestSort(event, { order: newOrder, orderBy: newOrderBy });
  };

  return (
    <TableCell
      key={headCell.id}
      align="left"
      sortDirection={orderBy === headCell.sortId ? order : false}
      style={{ whiteSpace: 'nowrap' }}
    >
      <TableSortLabel
        active={orderBy === headCell.sortId}
        direction={orderBy === headCell.sortId ? order : 'asc'}
        onClick={(event) => onSortHandle(event, headCell.sortId)}
        style={{ verticalAlign: 'baseline', width: '100%', fontWeight: 'bold' }}
      >
        {headCell.label}
        {orderBy === headCell.sortId ? (
          <Item>
            {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
          </Item>
        ) : null}
      </TableSortLabel>
    </TableCell>
  );
}
